import { ProfilePicture } from './ProfilePicture';
import { SRowContainer } from './ProfilePictureRow.styles';
import { getImageLink } from '../../utils/formatImageLink';

type ProfilePictureRowProps = {
  profilePictureFileNames: string[];
  isGroup?: boolean;
  diameter?: number;
};

export const ProfilePictureRow = (props: ProfilePictureRowProps) => {
  const { profilePictureFileNames, isGroup, diameter = 45 } = props;

  if (profilePictureFileNames.length > 0) {
    return (
      <SRowContainer diameter={diameter} role="profilePicturesRow">
        {profilePictureFileNames.map((img, key) => (
          <ProfilePicture
            key={key}
            diameter={diameter}
            isGroup={isGroup}
            readyPhotoSource={getImageLink({
              imageName: img,
              size: 'small',
            })}
            zIndex={profilePictureFileNames.length - key}
          />
        ))}
      </SRowContainer>
    );
  }

  return <ProfilePicture isGroup={isGroup} diameter={diameter} />;
};
